import { useSelector } from "react-redux";
import { Container } from "semantic-ui-react";
import ListaEstudios from "../../Shared/components/ListaEstudios/ListaEstudios";

import "./Completados.scss";

const Completados = () => {
	const user_id = parseInt(
		useSelector((state) => state.auth.id),
		10
	);
	return (
		<Container>
			<div className="header">Estudios - Completados</div>
			<div className="captura">
				<ListaEstudios status="4" user_id={user_id} />
			</div>
		</Container>
	);
};

export default Completados;
